import { Auth } from '../../util/auth';
import { getURL } from '../../util/util';


export var user = Auth.getUser();
/***********getting college data, required to show logos************/

export function getCollegeData() {
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/backgroundimageconfig/header/collegeinfo', {
    method: 'GET',
    headers: getHeaders(),
    mode: 'cors',
    cache: 'default',
  });

  return fetch(myRequest)
    .then(response => response.json())
    .then(response => {
      Auth.setCollegeDetails(response);
      return response;
    });
}

/**********************getting help desk info *********************/

export function getHelpDeskInfo() {
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/helpdesk/getinfo', {
    method: 'GET',
    headers: getHeaders(),
    mode: 'cors',
    cache: 'default',
  });

  return fetch(myRequest)
    .then(response => { return response.json() });

}

/*******************get notification count **********************/
export function getNotificationCount() {
  // var notifications;
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/notifications/active/' +
    Auth.getUser().id + '/' + Auth.getCurrentRole(), {
    method: 'GET',
    headers: getHeaders(),
  });

  return fetch(myRequest)
    .then(response => {
        return response.json();    
    });
}

// Sets & returns headers details
export function getHeaders() {
  var headers = new Headers();
  headers = {
    'Content-Type': 'application/json;',
    Authorization: 'Bearer ' + sessionStorage.getItem("token"),
    'tenant-id': Auth.getUser().tenantId,
    'academic-type': Auth.getUser().academicLevel,
    Accept: '*/*'
  };
  return headers;
}





export function markReadNotifications() {
  var myHeaders = getHeaders();
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/notifications/setasviewed/' + Auth.getUser().id, {
    method: 'PUT',
    headers: myHeaders,
    mode: 'cors',
    cache: 'default',
  });

  fetch(myRequest);
}

/**
* @description getHandlingDegreeDepartments is used to get HandlingDegreeDepartments from server based on userid and role.
* 
* @author Arupananda P
* @since June 26, 2020
*/
export function getHandlingDegreeDepartments() {
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/login/get-handling-degree-depts?userid=' +
    Auth.getUser().id + '&role=' + Auth.getCurrentRole(), {
    method: 'GET',
    headers: getHeaders(),
    mode: 'cors',
    cache: 'default',
  });

  return fetch(myRequest)
    .then(response => {
      return response.json();
    });
}

export function checkToChangeRole(role) {
  const user=Auth.getUser();
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/login/checkrole/' +
    user.id + '/' + role, {
    method: 'GET',
    headers: getHeaders(),
  });

  return fetch(myRequest).then(function (body) {
    return body.text();
  }).then(function (data) {
    return data;
  });
}

export function setUserSessionOut(email, userName) {
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/usersession/logout?email=' + email + '&username=' + userName, {
    method: 'GET',
    headers: getHeaders(),
  });

  return fetch(myRequest).then(response => {
    return response;
  });
}

export function searchUser(searchedText) {
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/profile/getlimitedsearchresult?name=' + searchedText, {
    method: 'GET',
    headers: getHeaders(),
    mode: 'cors',
    cache: 'default',
  });

  return fetch(myRequest)
    .then(response => { return response.json() });
}

export function getAccessToken() {
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/analytics/get-access-token?role=' + Auth.getCurrentRole(), {
    method: 'GET',
    headers: getHeaders(),
    mode: 'cors',
    cache: 'default',
  });
  return fetch(myRequest)
    .then(response => { 
      return response.json();
  });
}

export function getStudentFeeDetailsByConfiguration(){
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/studentprofile/get-student-fee-details?id=' +
  Auth.getUser().id + '&role=' + Auth.getCurrentRole(), {
  method: 'GET',
  headers: getHeaders(),
  mode: 'cors',
  cache: 'default',
});

return fetch(myRequest)
  .then(response => {
    return response.json();
  });
}

export function getAdmissionCommonConfig(){
  const myRequest = new Request(getURL(Auth.getAcademicLevel()).url + '/admissioncommonconfig/getadmissioncommonconfig', {
  method: 'GET',
  headers: getHeaders(),
  mode: 'cors',
  cache: 'default',
});

return fetch(myRequest)
  .then(response => {
    return response.json();
  });
}


export function getAllDueDateByDegree(degreeId) {
  const myRequest = new Request(
    getURL(Auth.getAcademicLevel()).url +
      `/duedatefine/find-all-due-date-and-fine-by-degree?degree=${degreeId}`,
    {
      method: 'GET',
      headers: getHeaders(),
      mode: 'cors',
      cache: 'default',
    }
  );

  return fetch(myRequest).then(response => response.json());
}

export function getStudentDataConfigByDegreeId(degreeId) {
  const myRequest = new Request(
    getURL(Auth.getAcademicLevel()).url +
      `/studentdataconfiguration/getstudentdataconfigurationbydegreeId?degreeid=${degreeId}`,
    {
      method: 'GET',
      headers: getHeaders(),
      mode: 'cors',
      cache: 'default',
    }
  );

  return fetch(myRequest).then(response => response.json());
}

export function getDefaultInformationForChild(childId) {
  const myRequest = new Request(
    getURL(Auth.getAcademicLevel()).url + `/parentdashboard/${childId}`,
    {
      method: 'GET',
      headers: getHeaders(),
      mode: 'cors',
      cache: 'default',
    }
  );

  return fetch(myRequest)
    .then(response => response.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error("Error fetching default information for child:", error);
    });
}